// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Buttons */
.condition-builder-btn {
  background-color: var(--color-icon-muted);
  color: var(--color-white);
  border: none;
  padding: 0.375rem 0.75rem;
  font-size: 0.875rem;
  border-radius: 0.25rem;
}

.add-group-btn {
  background-color: var(--color-primary-green);
  color: var(--color-white);
  border: none;
  padding: 0.375rem 0.75rem;
  font-size: 0.875rem;
  border-radius: 0.25rem;
}

.add-group-btn:hover {
  background-color: var(--color-primary-green);
}

.add-condition-btn {
  background-color: var(--color-primary-green);
  color: var(--color-white);
  border: none;
  padding: 0.375rem 0.75rem;
  font-size: 0.875rem;
  border-radius: 0.25rem;
}

.add-condition-btn:hover {
  background-color: var(--color-primary-green);
}

/* Card Body */
.condition-description {
  font-size: 0.75rem;
  color: var(--color-icon-muted);
}

/* Active Conditions Summary */
.active-conditions-label {
  font-size: 0.8rem;
  font-weight: 600;
}

.group-summary-badge {
  padding: 0.375rem 0.75rem;
  border-radius: 0.25rem;
  font-size: 0.8125rem;
  font-weight: 400;
  background-color: var(--color-white);
}

.and-separator-badge {
  padding: 0.25rem 0.5rem;
  border-radius: 20px;
  font-size: 0.75rem;
  font-weight: 600;
  background-color: #ffc107;
  color: #000;
  border: 2px solid #ffc107;
}

/* Group Colors */
.group-blue {
  border: 1px solid var(--color-link-blue);
  color: var(--color-link-blue);
}

.group-pink {
  border: 1px solid #d63384;
  color: #d63384;
}

.group-green {
  border: 1px solid #198754;
  color: #198754;
}

.group-orange {
  border: 1px solid #fd7e14;
  color: #fd7e14;
}

/* Condition Group Container */
.condition-group-container {
  border-radius: 0.375rem;
  padding: 0.5rem;
  margin-bottom: 1rem;
  background-color: var(--color-white);
}

.condition-group-blue {
  border: 2px solid var(--color-link-blue);
}

.condition-group-pink {
  border: 2px solid #d63384;
}

.condition-group-green {
  border: 2px solid #198754;
}

.condition-group-orange {
  border: 2px solid #fd7e14;
}

/* Group Badge - Made smaller */
.group-badge {
  padding: 0.25rem 0.5rem;
  border-radius: 0.25rem;
  font-size: 0.75rem;
  font-weight: 600;
  color: var(--color-white);
}

.group-badge-blue {
  background-color: var(--color-link-blue);
}

.group-badge-pink {
  background-color: #d63384;
}

.group-badge-green {
  background-color: #198754;
}

.group-badge-orange {
  background-color: #fd7e14;
}

/* Logic Dropdown - Made smaller */
.logic-dropdown {
  width: 70px;
  font-size: 0.75rem;
  padding: 0.25rem 0.5rem;
  border: 1px solid #ced4da;
  border-radius: 0.25rem;
}

/* Logic Label - Made smaller */
.logic-label {
  font-size: 0.75rem;
  color: var(--color-icon-muted);
}

/* Condition Number Badge - Made smaller and closer to edge */
/* Condition Number Badge - Made smaller and no extra margins */
.condition-number-badge {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 24px;
  height: 24px;
  border-radius: 50%;
  background-color: var(--color-icon-muted);
  color: var(--color-white);
  font-size: 0.7rem;
  font-weight: 600;
  margin: 0;
}

/* Reduce gap in Row for conditions */
.condition-group-container .g-2 {
  --bs-gutter-x: 0.25rem;
}
/* Form Controls */
.condition-select {
  font-size: 0.875rem;
  padding: 0.375rem 0.75rem;
  border: 1px solid #ced4da;
  border-radius: 0.25rem;
}

.condition-input {
  font-size: 0.875rem;
  padding: 0.375rem 0.75rem;
  border: 1px solid #ced4da;
  border-radius: 0.25rem;
}

/* Delete Button */
.delete-btn {
  background-color: transparent;
  border: none;
  color: var(--color-icon-muted);
  font-size: 1.125rem;
  padding: 0.25rem 0.5rem;
  cursor: pointer;
  transition: color 0.15s ease-in-out;
}

.delete-btn:hover {
  color: #dc3545;
}

.delete-btn i {
  font-size: 1rem;
}

/* AND/OR Separator Dropdown Between Groups */
.group-separator {
  text-align: center;
  margin: 1rem 0;
}

.group-separator-dropdown {
  display: inline-block;
  width: 100px;
  padding: 0.375rem 1.5rem;
  border-radius: 25px;
  font-size: 0.75rem;
  font-weight: 600;
  background-color: var(--color-white);
  color: #000;
  border: 2px solid #ffc107;
  text-align: center;
  cursor: pointer;
}

.group-separator-dropdown:focus {
  border-color: #ffc107;
  box-shadow: 0 0 0 0.2rem rgba(255, 193, 7, 0.25);
}

/* Reduce gap in Row for conditions */
.condition-group-container .g-2 {
  --bs-gutter-x: 0.5rem;
}

/* Responsive adjustments */
@media (max-width: 768px) {
  .condition-group-container {
    padding: 0.75rem;
  }
  
  .logic-dropdown {
    width: 65px;
    font-size: 0.7rem;
  }
}

/* Make all checkbox labels match the form-label size */
.form-check-label {
  font-size: 0.87rem !important;
  font-weight: 400 !important;
  color: #212529 !important;
}

/* Keep checkbox label on single line */
.single-line-checkbox label {
  white-space: nowrap !important;
}

.single-line-checkbox .form-check-label {
  white-space: nowrap !important;
}

/* Responsive: Allow wrapping on smaller screens */
@media (max-width: 992px) {
  .single-line-checkbox label {
    white-space: normal !important;
  }
  
  .single-line-checkbox .form-check-label {
    white-space: normal !important;
  }
}`, "",{"version":3,"sources":["webpack://./src/containers/vision_hub/email_rule/components/EmailConditionBuilder.css"],"names":[],"mappings":"AAAA,YAAY;AACZ;EACE,yCAAyC;EACzC,yBAAyB;EACzB,YAAY;EACZ,yBAAyB;EACzB,mBAAmB;EACnB,sBAAsB;AACxB;;AAEA;EACE,4CAA4C;EAC5C,yBAAyB;EACzB,YAAY;EACZ,yBAAyB;EACzB,mBAAmB;EACnB,sBAAsB;AACxB;;AAEA;EACE,4CAA4C;AAC9C;;AAEA;EACE,4CAA4C;EAC5C,yBAAyB;EACzB,YAAY;EACZ,yBAAyB;EACzB,mBAAmB;EACnB,sBAAsB;AACxB;;AAEA;EACE,4CAA4C;AAC9C;;AAEA,cAAc;AACd;EACE,kBAAkB;EAClB,8BAA8B;AAChC;;AAEA,8BAA8B;AAC9B;EACE,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA;EACE,yBAAyB;EACzB,sBAAsB;EACtB,oBAAoB;EACpB,gBAAgB;EAChB,oCAAoC;AACtC;;AAEA;EACE,uBAAuB;EACvB,mBAAmB;EACnB,kBAAkB;EAClB,gBAAgB;EAChB,yBAAyB;EACzB,WAAW;EACX,yBAAyB;AAC3B;;AAEA,iBAAiB;AACjB;EACE,wCAAwC;EACxC,6BAA6B;AAC/B;;AAEA;EACE,yBAAyB;EACzB,cAAc;AAChB;;AAEA;EACE,yBAAyB;EACzB,cAAc;AAChB;;AAEA;EACE,yBAAyB;EACzB,cAAc;AAChB;;AAEA,8BAA8B;AAC9B;EACE,uBAAuB;EACvB,eAAe;EACf,mBAAmB;EACnB,oCAAoC;AACtC;;AAEA;EACE,wCAAwC;AAC1C;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA,+BAA+B;AAC/B;EACE,uBAAuB;EACvB,sBAAsB;EACtB,kBAAkB;EAClB,gBAAgB;EAChB,yBAAyB;AAC3B;;AAEA;EACE,wCAAwC;AAC1C;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA,kCAAkC;AAClC;EACE,WAAW;EACX,kBAAkB;EAClB,uBAAuB;EACvB,yBAAyB;EACzB,sBAAsB;AACxB;;AAEA,+BAA+B;AAC/B;EACE,kBAAkB;EAClB,8BAA8B;AAChC;;AAEA,6DAA6D;AAC7D,+DAA+D;AAC/D;EACE,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,yCAAyC;EACzC,yBAAyB;EACzB,iBAAiB;EACjB,gBAAgB;EAChB,SAAS;AACX;;AAEA,qCAAqC;AACrC;EACE,sBAAsB;AACxB;AACA,kBAAkB;AAClB;EACE,mBAAmB;EACnB,yBAAyB;EACzB,yBAAyB;EACzB,sBAAsB;AACxB;;AAEA;EACE,mBAAmB;EACnB,yBAAyB;EACzB,yBAAyB;EACzB,sBAAsB;AACxB;;AAEA,kBAAkB;AAClB;EACE,6BAA6B;EAC7B,YAAY;EACZ,8BAA8B;EAC9B,mBAAmB;EACnB,uBAAuB;EACvB,eAAe;EACf,mCAAmC;AACrC;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,eAAe;AACjB;;AAEA,6CAA6C;AAC7C;EACE,kBAAkB;EAClB,cAAc;AAChB;;AAEA;EACE,qBAAqB;EACrB,YAAY;EACZ,wBAAwB;EACxB,mBAAmB;EACnB,kBAAkB;EAClB,gBAAgB;EAChB,oCAAoC;EACpC,WAAW;EACX,yBAAyB;EACzB,kBAAkB;EAClB,eAAe;AACjB;;AAEA;EACE,qBAAqB;EACrB,gDAAgD;AAClD;;AAEA,qCAAqC;AACrC;EACE,qBAAqB;AACvB;;AAEA,2BAA2B;AAC3B;EACE;IACE,gBAAgB;EAClB;;EAEA;IACE,WAAW;IACX,iBAAiB;EACnB;AACF;;AAEA,uDAAuD;AACvD;EACE,6BAA6B;EAC7B,2BAA2B;EAC3B,yBAAyB;AAC3B;;AAEA,uCAAuC;AACvC;EACE,8BAA8B;AAChC;;AAEA;EACE,8BAA8B;AAChC;;AAEA,kDAAkD;AAClD;EACE;IACE,8BAA8B;EAChC;;EAEA;IACE,8BAA8B;EAChC;AACF","sourcesContent":["/* Buttons */\n.condition-builder-btn {\n  background-color: var(--color-icon-muted);\n  color: var(--color-white);\n  border: none;\n  padding: 0.375rem 0.75rem;\n  font-size: 0.875rem;\n  border-radius: 0.25rem;\n}\n\n.add-group-btn {\n  background-color: var(--color-primary-green);\n  color: var(--color-white);\n  border: none;\n  padding: 0.375rem 0.75rem;\n  font-size: 0.875rem;\n  border-radius: 0.25rem;\n}\n\n.add-group-btn:hover {\n  background-color: var(--color-primary-green);\n}\n\n.add-condition-btn {\n  background-color: var(--color-primary-green);\n  color: var(--color-white);\n  border: none;\n  padding: 0.375rem 0.75rem;\n  font-size: 0.875rem;\n  border-radius: 0.25rem;\n}\n\n.add-condition-btn:hover {\n  background-color: var(--color-primary-green);\n}\n\n/* Card Body */\n.condition-description {\n  font-size: 0.75rem;\n  color: var(--color-icon-muted);\n}\n\n/* Active Conditions Summary */\n.active-conditions-label {\n  font-size: 0.8rem;\n  font-weight: 600;\n}\n\n.group-summary-badge {\n  padding: 0.375rem 0.75rem;\n  border-radius: 0.25rem;\n  font-size: 0.8125rem;\n  font-weight: 400;\n  background-color: var(--color-white);\n}\n\n.and-separator-badge {\n  padding: 0.25rem 0.5rem;\n  border-radius: 20px;\n  font-size: 0.75rem;\n  font-weight: 600;\n  background-color: #ffc107;\n  color: #000;\n  border: 2px solid #ffc107;\n}\n\n/* Group Colors */\n.group-blue {\n  border: 1px solid var(--color-link-blue);\n  color: var(--color-link-blue);\n}\n\n.group-pink {\n  border: 1px solid #d63384;\n  color: #d63384;\n}\n\n.group-green {\n  border: 1px solid #198754;\n  color: #198754;\n}\n\n.group-orange {\n  border: 1px solid #fd7e14;\n  color: #fd7e14;\n}\n\n/* Condition Group Container */\n.condition-group-container {\n  border-radius: 0.375rem;\n  padding: 0.5rem;\n  margin-bottom: 1rem;\n  background-color: var(--color-white);\n}\n\n.condition-group-blue {\n  border: 2px solid var(--color-link-blue);\n}\n\n.condition-group-pink {\n  border: 2px solid #d63384;\n}\n\n.condition-group-green {\n  border: 2px solid #198754;\n}\n\n.condition-group-orange {\n  border: 2px solid #fd7e14;\n}\n\n/* Group Badge - Made smaller */\n.group-badge {\n  padding: 0.25rem 0.5rem;\n  border-radius: 0.25rem;\n  font-size: 0.75rem;\n  font-weight: 600;\n  color: var(--color-white);\n}\n\n.group-badge-blue {\n  background-color: var(--color-link-blue);\n}\n\n.group-badge-pink {\n  background-color: #d63384;\n}\n\n.group-badge-green {\n  background-color: #198754;\n}\n\n.group-badge-orange {\n  background-color: #fd7e14;\n}\n\n/* Logic Dropdown - Made smaller */\n.logic-dropdown {\n  width: 70px;\n  font-size: 0.75rem;\n  padding: 0.25rem 0.5rem;\n  border: 1px solid #ced4da;\n  border-radius: 0.25rem;\n}\n\n/* Logic Label - Made smaller */\n.logic-label {\n  font-size: 0.75rem;\n  color: var(--color-icon-muted);\n}\n\n/* Condition Number Badge - Made smaller and closer to edge */\n/* Condition Number Badge - Made smaller and no extra margins */\n.condition-number-badge {\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  width: 24px;\n  height: 24px;\n  border-radius: 50%;\n  background-color: var(--color-icon-muted);\n  color: var(--color-white);\n  font-size: 0.7rem;\n  font-weight: 600;\n  margin: 0;\n}\n\n/* Reduce gap in Row for conditions */\n.condition-group-container .g-2 {\n  --bs-gutter-x: 0.25rem;\n}\n/* Form Controls */\n.condition-select {\n  font-size: 0.875rem;\n  padding: 0.375rem 0.75rem;\n  border: 1px solid #ced4da;\n  border-radius: 0.25rem;\n}\n\n.condition-input {\n  font-size: 0.875rem;\n  padding: 0.375rem 0.75rem;\n  border: 1px solid #ced4da;\n  border-radius: 0.25rem;\n}\n\n/* Delete Button */\n.delete-btn {\n  background-color: transparent;\n  border: none;\n  color: var(--color-icon-muted);\n  font-size: 1.125rem;\n  padding: 0.25rem 0.5rem;\n  cursor: pointer;\n  transition: color 0.15s ease-in-out;\n}\n\n.delete-btn:hover {\n  color: #dc3545;\n}\n\n.delete-btn i {\n  font-size: 1rem;\n}\n\n/* AND/OR Separator Dropdown Between Groups */\n.group-separator {\n  text-align: center;\n  margin: 1rem 0;\n}\n\n.group-separator-dropdown {\n  display: inline-block;\n  width: 100px;\n  padding: 0.375rem 1.5rem;\n  border-radius: 25px;\n  font-size: 0.75rem;\n  font-weight: 600;\n  background-color: var(--color-white);\n  color: #000;\n  border: 2px solid #ffc107;\n  text-align: center;\n  cursor: pointer;\n}\n\n.group-separator-dropdown:focus {\n  border-color: #ffc107;\n  box-shadow: 0 0 0 0.2rem rgba(255, 193, 7, 0.25);\n}\n\n/* Reduce gap in Row for conditions */\n.condition-group-container .g-2 {\n  --bs-gutter-x: 0.5rem;\n}\n\n/* Responsive adjustments */\n@media (max-width: 768px) {\n  .condition-group-container {\n    padding: 0.75rem;\n  }\n  \n  .logic-dropdown {\n    width: 65px;\n    font-size: 0.7rem;\n  }\n}\n\n/* Make all checkbox labels match the form-label size */\n.form-check-label {\n  font-size: 0.87rem !important;\n  font-weight: 400 !important;\n  color: #212529 !important;\n}\n\n/* Keep checkbox label on single line */\n.single-line-checkbox label {\n  white-space: nowrap !important;\n}\n\n.single-line-checkbox .form-check-label {\n  white-space: nowrap !important;\n}\n\n/* Responsive: Allow wrapping on smaller screens */\n@media (max-width: 992px) {\n  .single-line-checkbox label {\n    white-space: normal !important;\n  }\n  \n  .single-line-checkbox .form-check-label {\n    white-space: normal !important;\n  }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
